import { render, staticRenderFns } from "./ReopenBookingDialog.vue?vue&type=template&id=70f44e96&"
import script from "./ReopenBookingDialog.vue?vue&type=script&lang=js&"
export * from "./ReopenBookingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports